import React from 'react';

import { cn } from '@easydatasolution/config-tailwind/utils';
import { Link } from 'gatsby';

interface LogoProps {
	className?: string;
}

export const Logo = React.forwardRef<typeof Link, LogoProps>(({ className, ...rest }, ref) => {
	return (
		<Link
			ref={ref as any}
			to={'/'}
			className={cn('inline-block w-[280px] leading-none', className)}
			{...rest}
		>
			<svg role="img" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 590 181">
				<title>easy data solution GmbH Logo</title>
				<g clipPath="url(#a)">
					<path
						d="M587.11 133.89h-42.86a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M567.1 152.27c1.88 0 3.34.48 4.38 1.45 1.05.97 1.58 2.52 1.58 4.65v10.86h-3.53v-10.2c0-1.29-.27-2.26-.8-2.9-.53-.65-1.36-.98-2.47-.98-1.61 0-2.74.5-3.37 1.5-.62.98-.93 2.42-.93 4.3v8.28h-3.53v-16.65h2.75l.5 2.26h.19c.36-.58.8-1.06 1.34-1.43a5.97 5.97 0 0 1 1.8-.86 7.6 7.6 0 0 1 2.1-.28Z"
						fill="#fff"
					/>
					<path
						d="M526.86 133.89H484a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M513.58 160.53c0 1.38-.19 2.61-.55 3.68a6.95 6.95 0 0 1-4.07 4.4c-.97.39-2.07.58-3.3.58a8.4 8.4 0 0 1-3.14-.57 7.17 7.17 0 0 1-2.48-1.69 7.72 7.72 0 0 1-1.6-2.72c-.39-1.07-.58-2.3-.58-3.68 0-1.84.31-3.4.95-4.66a6.75 6.75 0 0 1 2.73-2.94c1.19-.67 2.6-1 4.23-1 1.53 0 2.89.33 4.06 1a6.96 6.96 0 0 1 2.75 2.94c.66 1.28 1 2.83 1 4.66Zm-12.08 0c0 1.21.14 2.25.44 3.11.3.86.76 1.53 1.38 1.99a4 4 0 0 0 2.4.67 4 4 0 0 0 2.41-.67 3.96 3.96 0 0 0 1.37-1.99c.29-.86.44-1.9.44-3.11a9.5 9.5 0 0 0-.44-3.09 3.79 3.79 0 0 0-1.37-1.94 4.03 4.03 0 0 0-2.42-.67c-1.46 0-2.53.49-3.2 1.47-.68.98-1.01 2.4-1.01 4.23Z"
						fill="#fff"
					/>
					<path
						d="M466.61 133.89h-42.86a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M446.15 152.58v16.65h-3.53v-16.65h3.53Zm-1.74-6.38c.54 0 1 .15 1.4.44.4.3.6.8.6 1.5s-.2 1.2-.6 1.5c-.4.3-.86.45-1.4.45-.56 0-1.04-.15-1.43-.44-.38-.3-.57-.8-.57-1.5 0-.72.19-1.22.57-1.5.39-.3.87-.44 1.43-.44Z"
						fill="#fff"
					/>
					<path
						d="M406.36 133.89H363.5a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M387.6 167.38a7.82 7.82 0 0 0 2.6-.43v2.67a10.14 10.14 0 0 1-3.46.62c-.95 0-1.8-.16-2.55-.47a3.72 3.72 0 0 1-1.79-1.64 6.5 6.5 0 0 1-.66-3.2v-8.95h-2.27v-1.57l2.44-1.25 1.16-3.57h2.22v3.7h4.77v2.7h-4.77v8.9c0 .84.21 1.47.63 1.88.43.4.98.61 1.67.61Z"
						fill="#fff"
					/>
					<path
						d="M346.11 133.89h-42.86a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M332.16 153.3v16.64h-2.78l-.48-2.24h-.2a4.8 4.8 0 0 1-1.34 1.43 5.9 5.9 0 0 1-1.8.83c-.66.19-1.36.28-2.1.28a7.5 7.5 0 0 1-3.21-.63 4.47 4.47 0 0 1-2.03-1.99 7.4 7.4 0 0 1-.7-3.46V153.3h3.54v10.21c0 1.3.26 2.26.78 2.9.53.65 1.36.97 2.47.97a4.4 4.4 0 0 0 2.56-.66 3.54 3.54 0 0 0 1.33-1.96c.28-.86.41-1.92.41-3.17v-8.29h3.55Z"
						fill="#fff"
					/>
					<path
						d="M285.86 133.89H243a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path d="M266.5 170.86h-3.55v-23.4h3.55v23.4Z" fill="#fff" />
					<path
						d="M225.61 133.89h-42.86a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M211.25 160.87c0 1.38-.19 2.61-.55 3.68a6.95 6.95 0 0 1-4.08 4.4c-.97.39-2.06.58-3.29.58a8.4 8.4 0 0 1-3.14-.57 7.16 7.16 0 0 1-2.48-1.69 7.72 7.72 0 0 1-1.61-2.72c-.38-1.07-.57-2.3-.57-3.68 0-1.84.31-3.4.95-4.66a6.75 6.75 0 0 1 2.73-2.94c1.19-.67 2.6-1 4.23-1 1.53 0 2.89.33 4.06 1a6.95 6.95 0 0 1 2.75 2.94c.66 1.28 1 2.83 1 4.66Zm-12.08 0c0 1.21.14 2.25.44 3.11.3.86.76 1.53 1.38 1.99a4 4 0 0 0 2.4.67 4 4 0 0 0 2.41-.67 3.97 3.97 0 0 0 1.37-1.99c.29-.86.44-1.9.44-3.11a9.5 9.5 0 0 0-.44-3.09 3.8 3.8 0 0 0-1.37-1.94 4.03 4.03 0 0 0-2.42-.67c-1.46 0-2.53.49-3.2 1.47-.68.99-1.01 2.4-1.01 4.23Z"
						fill="#fff"
					/>
					<path
						d="M165.36 133.89H122.5a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2v-42.86a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M150.15 165.19c0 1.09-.27 2.01-.8 2.77a4.9 4.9 0 0 1-2.33 1.7c-1.02.39-2.26.58-3.73.58-1.16 0-2.17-.08-3.01-.25-.83-.17-1.62-.42-2.36-.76v-3.05c.8.37 1.68.7 2.66.96 1 .27 1.93.4 2.81.4 1.17 0 2-.17 2.52-.53a1.74 1.74 0 0 0 .45-2.44c-.2-.29-.59-.59-1.15-.89-.55-.3-1.36-.68-2.43-1.1a20.3 20.3 0 0 1-2.66-1.27 4.65 4.65 0 0 1-1.65-1.52 4.33 4.33 0 0 1-.55-2.3c0-1.48.58-2.6 1.74-3.36a8.33 8.33 0 0 1 4.65-1.15 13.69 13.69 0 0 1 5.56 1.2l-1.1 2.66c-.76-.33-1.52-.6-2.28-.81a8.12 8.12 0 0 0-2.3-.33c-.91 0-1.6.14-2.09.42-.47.28-.7.68-.7 1.2 0 .4.1.72.34 1 .23.27.63.54 1.19.8.57.28 1.36.61 2.37 1.01 1 .38 1.85.79 2.57 1.2.74.42 1.3.92 1.69 1.53.39.6.59 1.38.59 2.33Z"
						fill="#fff"
					/>
					<path
						d="M225.61 66.94h-42.86a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V68.94a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M204.51 86.03c2.1 0 3.7.46 4.77 1.4 1.08.93 1.63 2.38 1.63 4.36v11.2h-2.52l-.67-2.36h-.12c-.47.6-.96 1.1-1.46 1.49-.5.39-1.08.68-1.75.87-.65.2-1.45.3-2.39.3-1 0-1.88-.18-2.66-.54a4.23 4.23 0 0 1-1.85-1.69 5.48 5.48 0 0 1-.68-2.85c0-1.72.64-3 1.91-3.87 1.29-.86 3.22-1.34 5.8-1.43l2.9-.1v-.87c0-1.16-.27-1.98-.82-2.47a3.2 3.2 0 0 0-2.25-.74c-.83 0-1.64.12-2.42.36s-1.55.54-2.29.9l-1.14-2.5a12.81 12.81 0 0 1 6.01-1.46Zm2.9 9-2.16.08c-1.76.06-3 .36-3.71.9a2.64 2.64 0 0 0-1.07 2.23c0 .82.24 1.42.74 1.8.49.37 1.13.56 1.94.56 1.22 0 2.23-.35 3.03-1.04.81-.7 1.22-1.73 1.22-3.08v-1.45Z"
						fill="#fff"
					/>
					<path
						d="M165.36 66.94H122.5a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V68.94a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M146.88 99.72a7.8 7.8 0 0 0 2.6-.43v2.67c-.39.18-.9.32-1.51.44-.63.12-1.27.18-1.94.18-.95 0-1.8-.16-2.55-.47a3.72 3.72 0 0 1-1.79-1.64 6.49 6.49 0 0 1-.66-3.2v-8.95h-2.27v-1.58l2.44-1.24 1.16-3.57h2.22v3.7h4.77v2.7h-4.77v8.9c0 .84.21 1.47.63 1.88.42.4.98.61 1.67.61Z"
						fill="#fff"
					/>
					<path
						d="M105.11 66.94H62.25a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V68.94a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M83 85.32c2.1 0 3.7.46 4.77 1.4 1.08.93 1.63 2.38 1.63 4.36v11.2h-2.52l-.67-2.36h-.12a8.6 8.6 0 0 1-1.46 1.49c-.5.39-1.08.68-1.75.87-.65.2-1.45.3-2.39.3-.99 0-1.88-.18-2.66-.54a4.23 4.23 0 0 1-1.85-1.69 5.48 5.48 0 0 1-.68-2.85c0-1.72.64-3 1.91-3.87 1.29-.86 3.22-1.34 5.8-1.43l2.9-.1v-.87c0-1.16-.27-1.98-.82-2.47a3.2 3.2 0 0 0-2.25-.74c-.83 0-1.64.12-2.42.36s-1.55.54-2.29.9L77 86.77A12.81 12.81 0 0 1 83 85.31Zm2.9 9-2.16.08c-1.76.06-3 .36-3.71.9a2.64 2.64 0 0 0-1.07 2.23c0 .82.24 1.42.74 1.8.49.37 1.13.56 1.94.56 1.22 0 2.23-.35 3.03-1.04.82-.7 1.22-1.73 1.22-3.08v-1.45Z"
						fill="#fff"
					/>
					<path
						d="M44.86 66.94H2a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V68.94a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M21.95 103.3a5.91 5.91 0 0 1-4.78-2.17c-1.2-1.46-1.8-3.6-1.8-6.43 0-2.85.62-5.01 1.83-6.48a5.98 5.98 0 0 1 4.83-2.2c.84 0 1.58.12 2.2.35.64.22 1.18.52 1.63.9.46.39.85.81 1.17 1.28h.17l-.18-1.34a16.3 16.3 0 0 1-.1-1.64V79.6h3.56v23.4H27.7l-.63-2.27h-.15a5.32 5.32 0 0 1-2.77 2.23c-.62.22-1.36.34-2.2.34Zm1-2.88c1.5 0 2.58-.44 3.2-1.31.62-.87.94-2.18.96-3.93v-.46c0-1.87-.3-3.3-.9-4.29-.6-1-1.7-1.5-3.3-1.5-1.27 0-2.24.51-2.91 1.55-.67 1.02-1 2.45-1 4.28 0 1.84.33 3.24 1 4.21a3.37 3.37 0 0 0 2.94 1.45Z"
						fill="#fff"
					/>
					<path
						d="M285.86 0H243a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M256.4 18.41h3.86l3.4 9.5a23.46 23.46 0 0 1 .99 3.7h.09c.1-.52.24-1.1.42-1.74.19-.65.4-1.3.63-1.95l3.28-9.5h3.8l-7.14 18.93c-.41 1.08-.92 2-1.52 2.76a5.81 5.81 0 0 1-4.89 2.35 10.6 10.6 0 0 1-2.26-.26v-2.82a7.59 7.59 0 0 0 1.8.2c.63 0 1.18-.13 1.64-.38.46-.25.85-.61 1.17-1.07.32-.45.58-.97.8-1.55l.58-1.57-6.65-16.6Z"
						fill="#fff"
					/>
					<path
						d="M225.61 0h-42.86a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M210.69 29.65c0 1.09-.27 2.01-.8 2.76a4.9 4.9 0 0 1-2.33 1.72c-1.02.38-2.26.57-3.73.57-1.17 0-2.17-.08-3.01-.26a10.3 10.3 0 0 1-2.36-.75v-3.05c.8.37 1.68.7 2.66.96 1 .27 1.93.4 2.81.4 1.17 0 2-.17 2.51-.53a1.74 1.74 0 0 0 .46-2.44c-.2-.29-.59-.59-1.15-.89-.55-.3-1.36-.68-2.43-1.1a20.3 20.3 0 0 1-2.66-1.27 4.63 4.63 0 0 1-1.64-1.52 4.32 4.32 0 0 1-.56-2.3c0-1.48.58-2.6 1.74-3.36a8.33 8.33 0 0 1 4.65-1.15 13.71 13.71 0 0 1 5.56 1.2l-1.1 2.66c-.76-.33-1.52-.6-2.28-.81a8.13 8.13 0 0 0-2.3-.33c-.91 0-1.6.14-2.09.42-.47.28-.7.68-.7 1.2 0 .4.1.72.34 1 .23.27.63.54 1.19.8.57.28 1.36.61 2.37 1.01 1 .39 1.85.79 2.57 1.2.74.42 1.3.92 1.69 1.53.39.6.59 1.38.59 2.33Z"
						fill="#fff"
					/>
					<path
						d="M165.36 0H122.5a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M143.25 17.44c2.1 0 3.7.46 4.77 1.4 1.08.93 1.63 2.38 1.63 4.36v11.2h-2.52l-.67-2.36h-.12c-.47.6-.96 1.1-1.46 1.49-.5.39-1.09.68-1.75.87-.65.2-1.44.3-2.39.3-.99 0-1.88-.18-2.66-.54a4.24 4.24 0 0 1-1.85-1.69 5.48 5.48 0 0 1-.68-2.85c0-1.72.64-3 1.91-3.87 1.29-.86 3.22-1.34 5.8-1.43l2.9-.1v-.87c0-1.16-.27-1.98-.82-2.47a3.2 3.2 0 0 0-2.25-.74c-.83 0-1.64.12-2.42.36s-1.55.54-2.29.9l-1.14-2.5a12.83 12.83 0 0 1 6.01-1.46Zm2.9 9-2.16.08c-1.76.06-3 .36-3.71.9a2.64 2.64 0 0 0-1.07 2.23c0 .82.24 1.42.73 1.8.5.37 1.14.56 1.94.56 1.23 0 2.24-.35 3.04-1.04.82-.7 1.22-1.73 1.22-3.08v-1.45Z"
						fill="#fff"
					/>
					<path
						d="M104.86 0H62a2 2 0 0 0-2 2v42.86c0 1.1.9 2 2 2h42.86a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z"
						fill="#EE7128"
					/>
					<path
						d="M83.97 18.1c1.48 0 2.76.3 3.82.91a6.15 6.15 0 0 1 2.45 2.6 8.8 8.8 0 0 1 .86 4.04v1.9H79.98c.04 1.6.47 2.85 1.3 3.72.83.87 2 1.3 3.49 1.3a12.37 12.37 0 0 0 5.49-1.21v2.87c-.84.4-1.68.68-2.55.86-.86.18-1.9.27-3.1.27a9.4 9.4 0 0 1-4.31-.95 6.93 6.93 0 0 1-2.9-2.85 9.7 9.7 0 0 1-1.04-4.71c0-1.87.31-3.45.95-4.75a6.83 6.83 0 0 1 2.66-2.98 7.66 7.66 0 0 1 4-1.02Zm0 2.66c-1.11 0-2.02.36-2.7 1.08a5.13 5.13 0 0 0-1.21 3.17h7.58a5.83 5.83 0 0 0-.42-2.2 3.2 3.2 0 0 0-1.2-1.51 3.57 3.57 0 0 0-2.05-.54Z"
						fill="#fff"
					/>
				</g>
				<defs>
					<clipPath id="a">
						<path fill="#fff" d="M0 0h589.11v180.75H0z" />
					</clipPath>
				</defs>
			</svg>
		</Link>
	);
});

Logo.displayName = 'Logo';
